// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-mobile{display:none}.card-desktop{visibility:block}@media only screen and (max-width:600px){.card-mobile{display:block}.card-desktop{display:none}}", ""]);
// Exports
module.exports = exports;
